module.exports = __webpack_public_path__ + "img/user.1cb6333c.png";